import React from "react";

const ChillerTruckFaq = ({ title, faqs }) => {
  return (
    <section className="ct-faq-section">
      <div className="container">
        <h2
          className="text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <div
          className="ct-faq-list"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          {faqs.map((faq, i) => (
            <div key={i} className="ct-faq-item">
              <p className="ct-faq-question">Q: {faq.q}</p>
              <p className="ct-faq-answer">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChillerTruckFaq;
